<body class="d-flex flex-column vh-100 position-relative">
    <div class="appBodyWrapper home d-flex h-100 flex-fill flex-column">
        <div class="appHeader position-relative">
            <div class="overly"></div>
            <div class="container position-relative z-3">
                <div class="logo text-center mb-4 pb-3">
                    <img src="./assets/images/TVS_Credit_logo.png" alt="logo" class="img-fluid" />
                </div>
                <div class="banner text-center">
                    <h5 class="fs-25 lh-24 fw-extrbold mb-4 pb-1 text-center text-green px-3">
                        Use the pre-approved credit limit facility to avail loans up to ₹ 1 Lakh
                    </h5>
                    
                    <figure class="figure text-center">
                        <img src="./assets/images/bannerImage.png" alt="" class="img-fluid" />
                    </figure>
                </div>
            </div>
        </div>
        <div class="appbody h-100">
            <div class="container h-100">
                <div class="card border-0 h-100">
                    <p class="fs-15 fw-bold lh-1 text-green text-center mb-4">Know your pre-approved credit limit</p>
                     <!-- <form action="#" class="common-form">  -->
                        <form [formGroup]="form" (ngSubmit)="toggleEditableotp($event)">
                            <div class="form-group">  
                        <label for="mobileNumber">Enter Your Mobile Number</label>
                        <div class="input-group">
                            <span class="input-group-text" style="font-family: 'Figtree'!important" id="mobileNumber">+91</span>
                            <input 
                            class="mobile-input"
                            style="font-family: 'Figtree'!important"
                            formControlName="mobileNumber" 
                            type="text" 
                            value="{{ mobileNumber }}"
                            class="form-control"
                            minlength="10"
                            maxlength="10"
                             id="mobileNumber" placeholder="Mobile Number"
                             [(ngModel)]="mobileNumber" 
                             />
                             <div *ngIf="submitted && f.mobileNumber.invalid " class="alert alert-error">  
                            

                                <div *ngIf="f.mobileNumber.errors.required">*Mobile Number is required.</div>  
                                <div *ngIf="f.mobileNumber.errors.pattern">*Please Enter Valid Mobile Number.</div>  
                            </div> 
                         </div> 
                        </div>
                        <div class="form-check mb-3" >
                            <input type="checkbox" class="form-check-input"  formControlName="acceptTerm" id="acceptTerm" name="acceptTerm"
                            required />
                            <span class="checkmark"></span>
                            <label class="form-check-label text-black-50 fs-12" for="acceptTerms">
                                I understand and agree to to the <a href="https://www.tvscredit.com/privacy-policy"  class="text-103864">Privacy Policy</a> and <a class="text-103864" data-toggle="modal" data-target="#screen-9">Term & Conditions</a>
                            </label>
                            <div *ngIf="submitted && f.acceptTerm.errors" class="alert alert-error1">
                                <!-- class="invalid-feedback" Requireddddd -->
                         <div *ngIf="f.acceptTerm.errors.required">*You must agree to the terms and conditions to proceed</div> 
                               </div>
                            </div>
                          
                          <button class="btn w-100 btn-primary fs-14 fw-medium rounded-pill" data-bs-toggle="modal" data-bs-target="#otpModal" type="submit"
                           >Get OTP</button>  
                          <!-- <div>
                            <span class="invalid-feedback">{{otpresponsemessage}} </span>
                        </div> -->
                    <!-- <a href="#" type="submit" [disabled]="!form.valid" class="btn w-100 btn-primary fs-14 fw-medium rounded-pill" data-bs-toggle="modal" data-bs-target="#otpModal">
                        <span>Get OTP</span>
                    </a> -->
                            
                    </form>
                    <!-- <div *ngIf="formError">
                        {{ formError }}
                      </div> -->
                </div>
            </div>
        </div>
        <!-- Modal -->
        <!-- <div class="modal fade appPoup" id="otpModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" > -->
            <div style="top: 58px !important;" id="otpModel" class="modal" aria-modal="true" role="dialog">  
            <div class="modal-dialog modal-dialog-end">
                <div class="modal-content">
                    <!-- <button type="button" class="btn-close position-absolute top-20 end-20" data-bs-dismiss="modal" aria-label="Close"></button> -->
                    <!-- <div class="modal-header border-0 px-0 pt-0">
                        <h2 class="modal-title fs-4 text-103864 fw-bold" id="exampleModalLabel">Confirm OTP</h2>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div> -->
                    <div class="modal-header text-white">
                        Confirm OTP
                        <button type="button" class="close text-white fa-2x" (click)="closeOtpModal()"  data-dismiss="modal">&times;</button>
                    </div>  
                    <div class="modal-body">
                        <div class="content">
                            <p class="fs-14 fw-medium text-black-50">OTP sent on {{mobileNumber}} <a href="javascript:void(0)"  (click)="resendotp()" class="text-103864 fw-semibold" >Resend</a></p>
                            <p class="fs-14 fw-medium text-black-50">This is not my registered mobile number <a href="javascript:void(0)" (click)="ChangeNumber()" class="text-103864 fw-medium"> Change number</a></p>
                        </div>
                        <form method="get" class="common-form otpFields mb-4 pb-1" [formGroup]="otpdetails" >

                            <div>
                                <span class="invalid-feedback">{{otpresponsemessage}} </span>
                            </div>
                            <div class="row form-row" >
                                <div class="col-2">
                                    <div class="input-wrap">
                                        <!-- <input type="text" class="form-control otpField otp_1" /> -->
                                        <input #input1 [type]="show ? 'text' : 'password'" pattern="[0-9]*" inputmode="numeric" formControlName="OTP1" [(ngModel)]="otp1" [ngClass]="{ 'is-invalid': submitted && o.OTP1.errors }[enable]" numberonly (keydown)="keyPress($event,1)" class="form-control {{enable}} text-center"
                                        tabindex="1" maxlength="1" id="1-otp" [appAutoTab]="input2" >
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="input-wrap">
                                        <input #input2 [type]="show ? 'text' : 'password'" pattern="[0-9]*" inputmode="numeric" formControlName="OTP2" [(ngModel)]="otp2" [ngClass]="{'is-invalid': submitted && o.OTP2.errors }" numberonly (keydown)="keyPress($event,2)" class="form-control {{enable}} text-center"
                                        tabindex="2" maxlength="1" id="2-otp" [appAutoTab]="input3" >
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="input-wrap">
                                        <input #input3 [type]="show ? 'text' : 'password'" pattern="[0-9]*" inputmode="numeric" formControlName="OTP3" [(ngModel)]="otp3" [ngClass]="{ 'is-invalid': submitted && o.OTP3.errors }" numberonly (keydown)="keyPress($event,3)" class="form-control {{enable}} text-center"
                                        tabindex="3" maxlength="1" id="3-otp" [appAutoTab]="input4">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="input-wrap">
                                        <input #input4 [type]="show ? 'text' : 'password'" pattern="[0-9]*" inputmode="numeric" formControlName="OTP4" [(ngModel)]="otp4" [ngClass]="{ 'is-invalid': submitted && o.OTP4.errors }" numberonly (keydown)="keyPress($event,4)" class="form-control {{enable}} text-center"
                                        tabindex="4" maxlength="1" id="4-otp" [appAutoTab]="input5">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="input-wrap">
                                        <input #input5 [type]="show ? 'text' : 'password'" pattern="[0-9]*" inputmode="numeric" formControlName="OTP5" [(ngModel)]="otp5" [ngClass]="{ 'is-invalid': submitted && o.OTP5.errors }" numberonly (keydown)="keyPress($event,5)" class="form-control {{enable}} text-center"
                                        tabindex="5" maxlength="1" id="5-otp" [appAutoTab]="input6">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="input-wrap">
                                        <input #input6 [type]="show ? 'text' : 'password'" pattern="[0-9]*" inputmode="numeric" formControlName="OTP6" [(ngModel)]="otp6" [ngClass]="{ 'is-invalid': submitted && o.OTP6.errors }" numberonly (keydown)="keyPress($event,6)" class="form-control {{enable}} text-center"
                                        tabindex="6" maxlength="1" id="6-otp" (blur)="callVerifyOtpBtn()">
                                    </div>
                                    <span class="invalid-feedback sent-otp"><b>{{incorrect}}</b></span>
                
                                            <div *ngIf="submitted || o.OTP1.errors  || o.OTP2.errors  || o.OTP3.errors  || o.OTP4.errors || o.OTP5.errors || o.OTP6.errors"> 
                                               <span class="invalid-feedback sent-otp"><b>{{otperror}}</b></span> 
                
                                            </div>
                                </div>
                            </div>
                            <div class="well-sm"></div>
                                    <div class="alignbutton {{verifyenable}}">
                                        <!-- <a (click)="resendotp()" class="inner">
                                            <img src="assets/img/resend.png" alt="resend">
                                        </a>&nbsp;&nbsp; -->
    
                                        <div class="sent-otp inner" *ngIf="hideVerifyBtn">
                                            <!--*ngif="IsshowVerifyBtn" <a class="btn request-a-demo" (click)="verify()"  id="submit2">Verify</a> -->
                                            <a class="btn request-a-demo "    (click)="verify()"
                                                id="submit2" vdata-toggle="modal" data-target="#reset-pin">Verify
                                                OTP</a>
                                        </div>
                                        <input formControlName="verifiedbox" (click)="verifyinput(val);"
                                            [(ngModel)]="verifiedotpclear" id="verifiedbox4" type="text"
                                            style="display: none;">
                                    </div>
                                    <div *ngIf="formSubmitted && otpNotEntered" class="invalid-feedback">
                                        <div><sup>*</sup>Please enter OTP</div>
                                    </div>
                                
                        </form>

                        <div class="btn-wrap text-center">
                            <a (click)="submit()" class="btn btn-primary fs-14 fw-semibold rounded-pill" >
                                <span>Confirm</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="modal fade screen-seventeen EligiblityPopup" id="screen-9" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
             <div class="modal-content">
            <div class="modal-header text-white" >
            <h5 class="modal-title" id="exampleModalLabel">Terms & Conditions</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
            <div class="separator"></div>
            </div>
            <div class="modal-body">
             <div class="row">
            <div class="col-md-12 col-12">
             <p >• I Voluntarily Opted for this process to update and share my KYC details with TVS Credit <br><br>
                • I Understand that completing this KYC process shall not guarantee sanctioning of Credit Limit or any other facility from TVS Credit <br><br>
                • I Authorise TVS Credit to share all or any part of the KYC / documents / CKYCR number with the partners in connection with the issuance of the InstaCard under the InstaCard Programme<br><br>
                • THIS IS NOT A CREDIT CARD, OR A DEBIT CARD OR A PREPAID CARD OR A STORED VALUE CARD etc. and It is issued by TVS Credit to the Borrower for easy identification and usage of the eligible loan limit with the TVS Credit partnered merchant (offline & online) networks. <br><br>
                • Loan at the Sole discretion of TVS Credit Services Limited <br><br>
                • Other Terms & Conditions Apply*
            </p>
             </div>
             </div>
             </div>
             </div>
             </div>
             </div>
        
    </div>
    <loader *ngIf="loader"></loader>
  </body>